export const SLUG_MAP: Record<string, string> = {
  sale:           'saleContact',
  business:       'businessContact',
  'job-detail':   'jobDetail',
  'job-position': 'jobPosition',
};

export const toApiSlug = (s: string): string => SLUG_MAP[s] ?? s;

export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];